import { useEffect, useState } from 'react';

import services from 'services';
import { HelpTopics } from 'types';

const useHelpTopics = () => {
  const [topics, setTopics] = useState<HelpTopics>(services.appFrame.help.getTopics);
  useEffect(() => {
    return services.appFrame.help.onTopicsChange(setTopics);
  }, []);

  return topics;
};

export default useHelpTopics;
